export default __webpack_public_path__ + "static/media/twitter.36b7eeb8.svg";